export default "<app-menu-edit demo=true></app-menu-edit>\n"